export const variations = {
  acquisition: [
    'valid-conversation',
    'general-notes',
    'lead-qualifier-scoring',
    'lead-qualifier-data',
  ],
  development: [
    'valid-conversation',
    'general-notes',
    'general-jtbd',
    'agent-jtbd',
    'lead-qualifier-scoring',
    'lead-qualifier-data',
  ],
} as const
